import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import randomString from "../utils/randomString";

function DesktopView(props) {
  useEffect(() => {
    function listener(event) {
      let message;

      try {
        message = JSON.parse(event.data);
      } catch (error) {
        return;
      }

      const messageData = message.data || {
        redirectUri: window.location.origin,
      };

      switch (message.name) {
        case 'init-auth-flow':
          window.location.href = `${process.env.REACT_APP_AUTHENTICATION_DOMAIN}/oauth2/login?redirect_uri=${messageData.redirectUri}&state=${randomString()}`;
          return;

        case 'init-logout-flow':
          window.location.href = `${message.data.logoutEndpoint}?redirect_uri=${window.location.origin}`;
          return;

        case 'set-named-user':
          // no-op
          return;
      }
    }

    window.addEventListener('message', listener, false);

    return function() {
      window.removeEventListener('message', listener, false);
    }
  }, []);

  return (
    <Container>
      <Inner>
        <IFrame src={`${window.location.origin}?contextVersion=desktop`} />
      </Inner>
    </Container>
  )
}

export default DesktopView;

const Container = styled.div`
  background-color: #fff;

  @media only screen and (min-width: 1024px) and (min-height: 768px) {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
  }
`;

const Inner = styled.div`
  flex-shrink: 0;
  //width: 414px;
  //height: 100%;
  width: 1024px;
  height: 768px;
  margin: 0 auto;

  box-shadow: 0 2rem 8rem rgba(0,0,0,.3);

  @media only screen and (min-width: 1080px) and (min-height: 810px) {
    width: 1080px;
    height: 810px;
  }

  @media only screen and (min-width: 1080px) and (min-height: 820px) {
    width: 1080px;
    height: 820px;
  }

  @media only screen and (min-width: 1112px) and (min-height: 834px) {
    width: 1112px;
    height: 834px;
  }

  @media only screen and (min-width: 1194px) and (min-height: 834px) {
    width: 1194px;
    height: 834px;
  }

  @media only screen and (min-width: 1180px) and (min-height: 820px) {
    width: 1180px;
    height: 820px;
  }

  @media only screen and (min-width: 1366px) and (min-height: 1024px) {
    width: 1366px;
    height: 1024px;
  }
`;

const IFrame = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: none;
`;
